import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import AidCard from '../FirstAid/components/AidCard/AidCard';
import fever from '../../assets/designSystem/icons/StaticPages/Symptoms/Adult/fever.svg';
import diarrhea from '../../assets/designSystem/icons/StaticPages/Symptoms/Adult/diarrhea.svg';
import vomitting from '../../assets/designSystem/icons/StaticPages/Symptoms/Adult/vomitting.svg';
import rash from '../../assets/designSystem/icons/firstAid/Symptoms/Rash.svg';
import cough from '../../assets/designSystem/icons/StaticPages/Symptoms/Adult/cough.png';
import earpain from '../../assets/designSystem/icons/StaticPages/Symptoms/Adult/earpain.png';
import './symptoms.css';
import BaseLayout from '../../commons/BaseLayout';
import KitoDoctorBuddy from '../../components/DoctorBuddy';

export default function AdultOptions() {
  const [searchQuery, setSearchQuery] = useState('');
  const [savedProgress, setSavedProgress] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const languagebaseLine = 'staticPages.signsAndSymptoms.adult';
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(
    () => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult'
  );

  const OPTIONS = [
    {
      name: 'fever',
      path: 'fever',
      title: t(`${languagebaseLine}.paths.fever.title`),
      subTitle: t(`${languagebaseLine}.paths.fever.subTitle`),
      progress: 0,
      image: fever,
      imgBgColor: '#2C75BA',
      backgroundColor: 'yellow',
      progressColor: 'blue',
      lastPage: 'lastPageChoking',
    },
    {
      name: 'Diarrhea',
      path: 'diarrhoea',
      title: t(`${languagebaseLine}.paths.diarrhea.title`),
      subTitle: t(`${languagebaseLine}.paths.diarrhea.subTitle`),
      progress: 0,
      image: diarrhea,
      imgBgColor: '#2C75BA',
      backgroundColor: 'blue',
      progressColor: 'blue',
      lastPage: 'lastPageChoking',
    },
    {
      name: 'Vomiting',
      path: 'vomiting',
      title: t(`${languagebaseLine}.paths.vomitting.title`),
      subTitle: t(`${languagebaseLine}.paths.vomitting.subTitle`),
      progress: 0,
      image: vomitting,
      imgBgColor: '#2C75BA',
      backgroundColor: 'green',
      progressColor: 'blue',
      lastPage: 'lastPageChoking',
    },
    {
      name: 'Rash',
      path: 'rash',
      title: t(`${languagebaseLine}.paths.rash.title`),
      subTitle: t(`${languagebaseLine}.paths.rash.subTitle`),
      progress: 0,
      image: rash,
      imgBgColor: 'yellow',
      backgroundColor: 'yellow',
      progressColor: 'yellow',
      lastPage: 'lastPageChoking',
    },
    {
      name: 'Cough',
      path: 'cough',
      title: t(`${languagebaseLine}.paths.cough.title`),
      subTitle: t(`${languagebaseLine}.paths.cough.subTitle`),
      progress: 0,
      image: cough,
      imgBgColor: 'orange',
      backgroundColor: 'orange',
      progressColor: 'orange',
      lastPage: 'lastPageChoking',
    },
    {
      name: 'Ear pain',
      path: 'ear-pain',
      title: t(`${languagebaseLine}.paths.earpain.title`),
      subTitle: t(`${languagebaseLine}.paths.earpain.subTitle`),
      progress: 0,
      image: earpain,
      imgBgColor: 'red',
      backgroundColor: 'red',
      progressColor: 'red',
      lastPage: 'lastPageChoking',
    },
  ];

  const filteredOptions = OPTIONS.filter((option) =>
    option.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    try {
      const stored = localStorage.getItem('symptomsProgress');
      const progress = stored ? JSON.parse(stored) : {};
      setSavedProgress(progress);
    } catch {
      setSavedProgress({});
    }
  }, []);

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar>
      <KitoDoctorBuddy
        title={t(`${languagebaseLine}.title`)}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        name="signsAndSymptoms"
        placeholder={t('firstAid.searchPlaceholder')}
      />
      <div className="symptom_cards">
        {filteredOptions.map((aid) => (
          <AidCard
            key={aid.title}
            title={aid.title}
            description={aid.subTitle}
            progressLabel={t('firstAid.progressLabel')}
            percent={savedProgress[aid.path]?.progress || 0}
            imageSrc={aid.image}
            backgroundColor={aid.backgroundColor}
            progressColor={aid.progressColor}
            imgBgColor={aid.imgBgColor}
            onClick={() => navigate(`/signs-symptoms/${aid.path}`)}
          />
        ))}
      </div>
    </BaseLayout>
  );
}
